import { render, staticRenderFns } from "./afterSaleCauseList.vue?vue&type=template&id=e7e3d1f6&scoped=true&"
import script from "./afterSaleCauseList.vue?vue&type=script&lang=js&"
export * from "./afterSaleCauseList.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleCauseList.vue?vue&type=style&index=0&id=e7e3d1f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e3d1f6",
  null
  
)

export default component.exports